import { FC, ReactElement } from 'react'

import FilterBlock from '../../../../components/Filters/subcomponents/FilterBlock/FilterBlock'
import { Checkbox, FilterSection } from '../../../components'
import { CheckboxList, IconButton } from '../../../compositions'
import { ConnectedResetFiltersButton } from '../../../connectors'
import { ValkTalkFeedType } from '../../../entities/ValkTalkPost/ValkTalkPost'
import trans from '../../../helpers/trans'
import { FormOption } from '../../../types'

import './ValkTalkPostsFilterContainer.scss'

interface ValkTalkPostsFilterContainerProps {
    canAddPost: boolean
    feedTypes: ValkTalkFeedType[]
    onlyOwnPosts: boolean
    onAddPostClick: () => void
    onFeedTypesChange: (feedTypes: ValkTalkFeedType[]) => void
    onOnlyOwnPostsChange: (onlyOwnPosts: boolean) => void
    className?: string
}

const feedTypeOptions: FormOption[] = Object.values(ValkTalkFeedType).map(feedType => ({
    label: trans(`types.valkTalkFeedType.${feedType}.filterLabel`),
    value: feedType,
}))

export const ValkTalkPostsFilterContainer: FC<ValkTalkPostsFilterContainerProps> = ({
    canAddPost,
    feedTypes,
    onlyOwnPosts,
    onAddPostClick,
    onFeedTypesChange,
    onOnlyOwnPostsChange,
    className = '',
}): ReactElement => (
    <div className={`valk-talk-posts-filter-container ${className}`}>
        {canAddPost && (
            <FilterSection className="valk-talk-posts-filter-container__add-post-section">
                <IconButton
                    icon="plus"
                    text={trans('containers.valkTalkPosts.addPost')}
                    onClick={onAddPostClick}
                    className="valk-talk-posts-filter-container__add-post-button"
                />
            </FilterSection>
        )}

        <FilterSection>
            <ConnectedResetFiltersButton />
        </FilterSection>

        <FilterSection>
            <FilterBlock title={trans('containers.valkTalkPosts.filters.feedTypes')}>
                <CheckboxList
                    hideLabel
                    label={trans('containers.valkTalkPosts.filters.feedTypes')}
                    name="valk-talk-posts-feed-types"
                    options={feedTypeOptions}
                    value={feedTypes}
                    onChange={values => onFeedTypesChange(values as ValkTalkFeedType[])}
                    className="valk-talk-posts-filter-container__filter-checkbox-set"
                    labelClassName="valk-talk-posts-filter-container__filter-checkbox-set-checkbox-label"
                />
            </FilterBlock>
        </FilterSection>

        <FilterSection>
            <FilterBlock title={trans('containers.valkTalkPosts.filters.author')}>
                <Checkbox
                    checked={onlyOwnPosts}
                    label={trans('containers.valkTalkPosts.filters.onlyOwnPosts')}
                    onChange={onOnlyOwnPostsChange}
                    className="valk-talk-posts-filter-container__filter-checkbox-set"
                    labelClassName="valk-talk-posts-filter-container__filter-checkbox-set-checkbox-label"
                />
            </FilterBlock>
        </FilterSection>
    </div>
)
